module.exports = __webpack_public_path__ + "img/6.f20529d3.png";